"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMultiColumn;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIMultiColumn(props) {
  var children = props.children,
      className = props.className,
      flush = props.flush,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "flush"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, other, {
    className: (0, _classnames.default)('private-multicolumn', {
      'private-multicolumn--flush': flush
    }, className)
  }), children);
}

UIMultiColumn.displayName = 'UIMultiColumn';
UIMultiColumn.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool.isRequired
};
UIMultiColumn.defaultProps = {
  flush: false
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/layout/UIMultiColumn.js
// module id = 843
// module chunks = 5 6